<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-stopwatch"></i> {{"TITLE.TOO-MUCH-DOWNTIME" | translate}}</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="accept()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
    <i class="fa fa-info-circle text-info"></i>&nbsp;
      <a [innerHTML]="message.replace('P_MINUTES', minutesLeft.toString()).replace('P_SECONDS', secondsLeft.toString())"></a>
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="keepSession()">
      <i class="far fa-play-circle"></i> {{"BUTTON.KEEP-SESSION"| translate}}
    </button>
    <button type="button" class="btn btn-danger"
            (click)="accept()">{{"BUTTON.ACCEPT" | translate}}
    </button>
  </div>
</div>
